import { Component, OnInit, Input, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'core/components/modal/modal.component';
import { JobsService } from 'core/services/jobs.service';
import { LocalesService } from 'core/services';
import { DynamicFormComponent, QuestionBase, CheckboxQuestion } from 'core/components';

@Component({
  selector: 'lms-download-documentation-courses',
  templateUrl: './download-documentation-courses.component.html',
  styleUrls: ['./download-documentation-courses.component.scss']
})
export class DownloadDocumentationComponent implements OnInit {
  @Output() confirm = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  @ViewChild('modalDownloadDocumentation', { static: false }) public modalDownloadDocumentation: ModalComponent;
  @Input() languagesCourses: any = [];
  public selectedCourses: any;
  public languagesQuestions: QuestionBase<any>[] = [];
  constructor(
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public elementRef: ElementRef,
    public jobsService: JobsService,
    public locales: LocalesService
  ) {}

  ngOnInit() {}

  downloadDocumentation(languages) {
    const checkedLanguages = Object.keys(languages).filter((lang) => languages[lang]);
    const jobData = {
      jobType: this.jobsService.jobTypes.DOWNLOAD_COURSE_DOCUMENTATION_BULK,
      courses: [...this.selectedCourses.keys()].map((id) => ({ id })),
      lang: checkedLanguages
    };
    this.confirm.emit(jobData);
    this.cancelModal();
  }

  openModal(selectedCourses) {
    this.selectedCourses = selectedCourses;
    this.setLanguages(selectedCourses);
    this.modalDownloadDocumentation.open();
  }
  cancelModal() {
    this.modalDownloadDocumentation.close();
  }

  setLanguages(selectedCourses) {
    selectedCourses.forEach((course) => {
      course.languages.forEach((lang) => {
        if (!this.languagesCourses.includes(lang)) {
          this.languagesCourses.push(lang);
        }
      });
    });
    this.languagesQuestions = this.languagesCourses.map((lang) => this.newCheckbox(lang));
  }

  newCheckbox(lang) {
    return new CheckboxQuestion({
      key: lang,
      class: 'col-1',
      label: this.locales.getLocaleName(lang),
      value: ''
    });
  }

  public ngOnDestroy(): void {}
}
